import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Flexbox } from '@piconetworks/pkg-box';
import styles from './Boutton.module.scss.js';

var _excluded = ["active", "block", "children", "className", "flexboxContainer", "icon", "size", "submitting", "toggle", "type", "variant"];
var LoadingIcon = function LoadingIcon(_ref) {
  var className = _ref.className,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '56' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '56' : _ref$height;
  return /*#__PURE__*/React.createElement("svg", {
    height: height,
    width: width,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    role: "status"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,14.258231 23.3762203,16.3707704 22.2915649,18.1747141 L20.5763803,17.1454684 C21.4802128,15.6422098 22,13.8818063 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,13.8822261 2.52001916,15.6429951 3.42422463,17.1464744 L1.70903973,18.1757196 C0.624011557,16.3715554 0,14.2586506 0,12 C0,5.372583 5.372583,0 12,0 Z",
    fill: "currentcolor",
    fillRule: "evenodd"
  }));
};
LoadingIcon.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  height: PropTypes.string,
  width: PropTypes.string
};
var Boutton = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var active = _ref2.active,
    block = _ref2.block,
    children = _ref2.children,
    className = _ref2.className,
    flexboxContainer = _ref2.flexboxContainer,
    icon = _ref2.icon,
    size = _ref2.size,
    submitting = _ref2.submitting,
    toggle = _ref2.toggle,
    type = _ref2.type,
    variant = _ref2.variant,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var classes = cx('btn', active && 'active', icon && 'btn-icon', variant && "btn-" + variant, !children && 'btn-no-text', block && 'btn-block', size && "btn-" + size, submitting && styles['btnSubmitting'], toggle && 'btn-toggle', className);
  if (props.disabled || submitting) {
    props.disabled = true;
  }
  if (toggle) {
    return /*#__PURE__*/React.createElement("label", _extends({}, props, {
      className: classes
    }), children);
  }
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    type: type,
    className: classes
  }, props), /*#__PURE__*/React.createElement(Flexbox.Container, flexboxContainer, icon && !submitting && /*#__PURE__*/React.createElement(React.Fragment, null, icon, children && /*#__PURE__*/React.createElement("span", null, children)), submitting && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadingIcon, {
    className: styles.isSubmitting,
    variant: variant
  }), children && /*#__PURE__*/React.createElement("span", null, children)), !icon && !submitting && children));
});
Boutton.displayName = 'Boutton';
Boutton.propTypes = {
  /** Manually set the visual state of the button to `:active` */
  active: PropTypes.bool,
  /** Spans the full width of the Boutton parent */
  block: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  'data-testid': PropTypes.string,
  /**
   * Disables the Boutton, preventing mouse events,
   * even if the underlying component is an `<a>` element
   */
  disabled: PropTypes.bool,
  flexboxContainer: PropTypes.object,
  icon: PropTypes.any,
  /**
   * Specifies a large or small button.
   *
   * @type ('sm'|'lg')
   */
  size: PropTypes.oneOf(['sm', 'lg']),
  /**
   * Whether the loading icon shows or not
   */
  submitting: PropTypes.bool,
  // instead of a button component, we will use a label instead
  toggle: PropTypes.bool,
  /**
   * Defines HTML button type attribute.
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit', null]),
  /**
   * Bouttons may be one of a variety of visual variants
   */
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'dangerous', 'warning', 'info', 'dark', 'light', 'link', 'facebook', 'github', 'google', 'linkedin', 'twitter'])
};
Boutton.defaultProps = {
  block: false,
  disabled: false,
  flexboxContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap'
  },
  icon: false,
  submitting: false,
  toggle: false,
  type: 'button'
};

export { Boutton as default };
//# sourceMappingURL=index.js.map
